/** @format */

import React, { useCallback, useEffect, useState } from 'react';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { useDispatch } from 'react-redux';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { UserPermissionGroupModify } from './UserPermissionGroupModify';
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import { useParams } from 'react-router-dom';
import { configDefault } from '../../core/config';
import PlatformUserDefinedRolesInterface, {
    PlatformUserDefinedRolesToSendInterface,
} from '../../interfaces/platform/PlatformUserDefinedRolesInterface';
import { platformGroupsConstants, platformUserDefinedRolesToGroupsConstants } from '../../modules/platformGroups/reducers';
import { NotificationHelper } from '../../helpers/NotificationHelper';

export const UserPermissionGroupEdit = (): React.ReactElement => {
    const dispatch = useDispatch();
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const { id } = useParams();

    const [outputObject, setOutputObject] = useState<any>({
        mainname: '',
        rootOnly: false,
    });

    const PLATFORM_GROUP_ROLES_TO_GROUP_URI = '/platform_user_defined_roles_to_groups';

    const [checkedElements, setCheckedElements] = useState<Array<string>>([]);

    const savePermissionGroup = (outputObject: any): void => {
        if (!id || outputObject.mainname === '') {
            return;
        }

        if (outputObject.ttlToken) {
            outputObject.ttlToken = parseInt(outputObject.ttlToken);
        } else {
            outputObject.ttlToken = 1800;
        }

        if (outputObject.accountExpiration) {
            outputObject.accountExpiration = parseInt(outputObject.accountExpiration);
        }

        if (!Number.isInteger(outputObject.accountExpiration)) {
            NotificationHelper.notifyError('permission_groups:err.password_expiration_not_int', dispatch);
            return;
        }

        if (outputObject.accountExpiration <= 0) {
            NotificationHelper.notifyError('permission_groups:err.password_expiration_short', dispatch);
            return;
        }

        outputObject.params = JSON.stringify(checkedElements);

        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.putWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_user_defined_roles/' + id, configDefault.PLATFORM_API_PREFIX)),
            platformGroupsConstants.EDIT,
            outputObject,
            (): void => {},
            {
                dispatchAfterCallback: true,
                dispatchErrorAfterCallback: true,
            }
        );
    };

    const firstLoad = useCallback(
        (uri?: string) => {
            if (!uri) {
                uri = FormGeneralHelper.getPath(PLATFORM_GROUP_ROLES_TO_GROUP_URI);
            }
            const itemLoaders = new ItemLoaders(dispatch);
            itemLoaders.getListWithCallback(
                FormGeneralHelper.getByUri(uri),
                platformUserDefinedRolesToGroupsConstants.LIST,
                [{ name: 'platformUserDefinedRoleId', value: id }],
                [],
                (data: any) => {
                    let elements = [];
                    if (data && data['hydra:member']) {
                        elements = data['hydra:member'].map((el: any) => {
                            return el.permissionRoleName;
                        });
                    }
                    setCheckedElements(elements);
                },
                {
                    propagateDataToCallback: true,
                    dispatchAfterCallback: false,
                }
            );
        },
        [dispatch, id]
    );

    useEffect(() => {
        if (!id) {
            return;
        }

        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.getWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_user_defined_roles/' + id, configDefault.PLATFORM_API_PREFIX)),
            platformGroupsConstants.ITEM,
            (data: PlatformUserDefinedRolesInterface): void => {
                const tmpOutputObject = {
                    mainname: data.mainname ?? '',
                    ttlToken: data.ttlToken ?? 1800,
                    accountExpiration: data.accountExpiration ?? 30,
                } as PlatformUserDefinedRolesToSendInterface;
                setOutputObject(tmpOutputObject);
            },
            { dispatchAfterCallback: false, propagateDataToCallback: true, dispatchErrorAfterCallback: true }
        );
    }, [dispatch, id]);

    useEffect(() => {
        firstLoad();
    }, [firstLoad]);

    return (
        <UserPermissionGroupModify
            userId={id}
            outputObject={outputObject}
            savePermissionGroup={savePermissionGroup}
            checkedElements={checkedElements}
            setCheckedElements={setCheckedElements}
            id={id}
        />
    );
};
